import { Type } from 'lucide-react';
import React from 'react';
import { TextShape } from '../../../../../../types';
import {
  Popover,
  PopoverContent,
  PopoverTrigger
} from '../../../../../ui/popover';
import { useMapEditor } from '../../../../contexts/MapEditorContext';

export interface ShapeToolboxTextItemsProps {
  shape: TextShape;
}

export const ShapeToolboxTextItems: React.FC<ShapeToolboxTextItemsProps> = ({
  shape
}) => {
  const { updateShape } = useMapEditor();

  const handleFontSizeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    if (shape.type === 'text') {
      updateShape(shape.id, { fontSize: Number.parseInt(e.target.value) });
    }
  };

  const handleFontFamilyChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    if (shape.type === 'text') {
      updateShape(shape.id, { fontFamily: e.target.value });
    }
  };

  return (
    <>
      <div className="w-px h-4 bg-gray-200" />
      <Popover>
        <PopoverTrigger asChild>
          <button
            className="p-1 rounded hover:bg-gray-100 transition-colors flex items-center gap-1"
            title="Text Options"
          >
            <Type size={16} className="text-gray-600" />
          </button>
        </PopoverTrigger>
        <PopoverContent className="w-64 p-3" align="start" side={'top'}>
          <div className="flex flex-col gap-3">
            <div className="flex flex-col gap-1">
              <div className="text-sm font-medium">Font Size</div>
              <select
                value={(shape as TextShape).fontSize}
                onChange={handleFontSizeChange}
                className="w-full rounded-md border border-gray-200 p-2"
              >
                {[12, 14, 16, 18, 20, 24, 28, 32, 36, 40, 48, 56, 64, 72].map(
                  (size) => (
                    <option key={size} value={size}>
                      {size}px
                    </option>
                  )
                )}
              </select>
            </div>
            {/*<div className="flex flex-col gap-1">
              <div className="text-sm font-medium">Font Family</div>
              <select
                value={(shape as TextShape).fontFamily}
                onChange={handleFontFamilyChange}
                className="w-full rounded-md border border-gray-200 p-2"
              >
                {[
                  'Arial',
                  'Times New Roman',
                  'Helvetica',
                  'Courier New',
                  'Georgia',
                  'Verdana',
                  'Impact'
                ].map((font) => (
                  <option key={font} value={font}>
                    {font}
                  </option>
                ))}
              </select>
            </div>*/}
          </div>
        </PopoverContent>
      </Popover>
    </>
  );
};
